module.exports = "../../../../platform/assets/pageMainIcon/business_yewushezhilei6.svg";